module.exports = __webpack_public_path__ + "img/L_314_0.48a31a15.png";